/**
 * The slug rule for panel forms, the same as the API's (apps.core.slugs): letters (a-z, A-Z), numbers (0-9) and
 * dashes (-), not starting or ending with a dash. Empty is allowed: the server makes the slug from the name.
 *
 *     const slugField = useSlugField();
 *     const schema = z.object({ slug: slugField(140) });
 */

import { z } from "zod";

import { useTranslation } from "@motolynk/i18n";

export const SLUG_PATTERN = /^([A-Za-z0-9]+(-+[A-Za-z0-9]+)*)?$/;

export function isValidSlug(value: string): boolean {
  return SLUG_PATTERN.test(value);
}

/** `slugField(max)` → a Zod string rule with the slug pattern and a translated message. */
export function useSlugField(): (max: number) => z.ZodString {
  const { t } = useTranslation("common");
  return (max) =>
    z
      .string()
      .trim()
      .max(max, t("errors.slugTooLong", { count: max }))
      .regex(SLUG_PATTERN, t("errors.slug"));
}
